/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Button } from '@components/atoms'

import { grey } from '@mui/material/colors'

interface PropsType {
	className: string
}

export const TermsView = (props: PropsType) => {
	return (
		<View css={style} className={props.className}>
			<p className="termsText">
				‘로그인’ 버턴을 누르시면 아래 내용에 동의함을 의미합니다.{' '}
				<Button variant="text" className="termsButton">
					개인정보보호방지
				</Button>
				<span> 및 </span>
				<Button variant="text" className="termsButton">
					최종 사용자 라이선스
				</Button>
			</p>
		</View>
	)
}

const style = css({
	'.termsText': {
		fontFamily:
			"-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
		lineHeight: 1.3,
		letterSpacing: 0,
		fontSize: '12px',
		fontWeight: '300',
		color: grey[500],

		'.termsButton': {
			padding: 0,
			fontFamily:
				"-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
			lineHeight: 1,
			letterSpacing: 0,
			fontSize: '12px',
			fontWeight: '300',
			color: grey[500],
			textDecoration: 'underline',
		},
	},
})
